import api from "./api";

export async function uploadToCloudinary(file, folder = "hoardexa/hoardings/") {
  const { data: sig } = await api.get("/cloudinary/signature", { params: { folder } });
  const form = new FormData();
  form.append("file", file);
  form.append("api_key", sig.api_key);
  form.append("timestamp", sig.timestamp);
  form.append("signature", sig.signature);
  form.append("folder", sig.folder);
  const url = `https://api.cloudinary.com/v1_1/${sig.cloud_name}/image/upload`;
  const res = await fetch(url, { method: "POST", body: form });
  if (!res.ok) {
    const err = await res.text();
    throw new Error(`Upload failed: ${err}`);
  }
  const json = await res.json();
  return { url: json.secure_url, public_id: json.public_id };
}
